/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { useEffect, useRef, useState } from "react";

export function useUnsavedChanges() {
  const [isDirty, setIsDirty] = useState(false);
  const enabledRef = useRef(false);

  useEffect(() => {
    enabledRef.current = isDirty;
  }, [isDirty]);

  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (!enabledRef.current) return;
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);

  const confirmNavigate = async () => {
    if (!enabledRef.current) return true;
    // eslint-disable-next-line no-alert
    const ok = window.confirm(
      "You have unsaved changes. Are you sure you want to leave this page?",
    );
    return ok;
  };

  return { isDirty, setIsDirty, confirmNavigate };
}
